(() => {
  if (customElements.get('bundle-carousel')) {
    return;
  }

  class BundleCarousel extends HTMLElement {
    constructor() {
      super();
      this.options = {
        slidesPerView: 'auto',
        spaceBetween: 8,
        // If we need a scrollbar
        scrollbar: {
          el: '.swiper-scrollbar',
          hide: false, // set to false to make the scrollbar always visible
          draggable: true, // allows users to drag the scrollbar to control position
        },
      };
    }

    connectedCallback() {
      this.swiperInstance = new Swiper(this, this.options);
    }
  }

  customElements.define('bundle-carousel', BundleCarousel);
})();
